module.exports = __webpack_public_path__ + "img/banano-banner.156a73b8.png";